export const actions = {
    async submit({ state }, payload) {
        await this.$axios.delete(`/v2/application/package/${payload.id}`, payload.data);
    },
};
